module.exports = __webpack_public_path__ + "media/images/pic/hero-a274f16d336c045a9c8fc764d59ebe7c.png";